import axios from 'axios';

const TOKEN_STORAGE_KEYS = [
  'jwt',
  'jwtToken',
  'authToken',
  'authenticationToken',
  'token',
  'access_token',
  'id_token',
  'jhi-authenticationToken',
];

const TOKEN_COOKIE_KEYS = [
  'jwt',
  'jwtToken',
  'authToken',
  'token',
  'access_token',
  'id_token',
  'jhi-authenticationToken',
];

const toStringSafe = value => String(value == null ? '' : value).trim();

const extractToken = value => {
  const normalized = toStringSafe(value);
  if (!normalized) return '';
  return normalized.replace(/^Bearer\s+/i, '').trim();
};

const readFromStorage = storage => {
  if (!storage) return '';
  for (const key of TOKEN_STORAGE_KEYS) {
    const token = extractToken(storage.getItem(key));
    if (token) return token;
  }
  return '';
};

const readFromCookies = () => {
  const raw = toStringSafe(typeof document === 'undefined' ? '' : document.cookie);
  if (!raw) return '';

  const map = raw
    .split(';')
    .map(x => x.trim())
    .filter(Boolean)
    .reduce((acc, item) => {
      const idx = item.indexOf('=');
      if (idx <= 0) return acc;
      const key = decodeURIComponent(item.slice(0, idx).trim());
      const value = decodeURIComponent(item.slice(idx + 1).trim());
      acc[key] = value;
      return acc;
    }, {});

  for (const key of TOKEN_COOKIE_KEYS) {
    const token = extractToken(map[key]);
    if (token) return token;
  }
  return '';
};

export function resolveJwtToken() {
  const defaultAuthHeader = axios?.defaults?.headers?.common?.Authorization;
  const fromDefaults = extractToken(defaultAuthHeader);
  if (fromDefaults) return fromDefaults;

  if (typeof window === 'undefined') return '';

  const fromLocalStorage = readFromStorage(window.localStorage);
  if (fromLocalStorage) return fromLocalStorage;

  const fromSessionStorage = readFromStorage(window.sessionStorage);
  if (fromSessionStorage) return fromSessionStorage;

  return readFromCookies();
}

export function resolveAuthHeaderValue() {
  const token = resolveJwtToken();
  return token ? `Bearer ${token}` : '';
}

export function clearAuthTokens() {
  if (typeof window === 'undefined') return;
  TOKEN_STORAGE_KEYS.forEach(key => {
    try { window.localStorage.removeItem(key); } catch (_) { /* no-op */ }
    try { window.sessionStorage.removeItem(key); } catch (_) { /* no-op */ }
  });
  try { delete axios.defaults.headers.common.Authorization; } catch (_) { /* no-op */ }
}
